(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zt-flavor-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class ZtFlavorTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-zt-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-zt-panel]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.handleClick(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
    }

    handleClick(tab) {
      const action = tab.dataset.ztAction || 'products';
      const url = tab.dataset.ztUrl || '';

      if (action === 'collection' && url) {
        window.location.assign(url);
        return;
      }

      this.activate(tab.dataset.ztTab);
    }

    activate(name, moveFocus = false) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.ztTab === name;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;

        if (isActive && moveFocus) tab.focus();
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.ztPanel === name;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });
    }

    handleKeydown(event, currentIndex) {
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activate(this.tabs[nextIndex].dataset.ztTab, true);
    }
  }

  if (!customElements.get('zt-flavor-tabs')) {
    customElements.define('zt-flavor-tabs', ZtFlavorTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zt-size-tabs"] && !Shopify.designMode) return;
  try {
    

  class ZtSizeTabs extends HTMLElement {

    connectedCallback() {

      if (this.dataset.ready === 'true') {
        return;
      }

      this.dataset.ready =
        'true';

      this.tabs =
        Array.from(
          this.querySelectorAll(
            '[data-zt-size-tab]'
          )
        );

      this.panels =
        Array.from(
          this.querySelectorAll(
            '[data-zt-size-panel]'
          )
        );


      this.tabs.forEach(
        (tab, index) => {

          tab.addEventListener(
            'click',
            () => {
              this.activate(
                tab.dataset.ztSizeTab
              );
            }
          );


          tab.addEventListener(
            'keydown',
            (event) => {

              this.handleKeydown(
                event,
                index
              );

            }
          );

        }
      );

    }


    activate(
      name,
      moveFocus = false
    ) {

      this.tabs.forEach(
        (tab) => {

          const isActive =
            tab.dataset.ztSizeTab === name;


          tab.classList.toggle(
            'is-active',
            isActive
          );


          tab.setAttribute(
            'aria-selected',
            isActive
              ? 'true'
              : 'false'
          );


          tab.tabIndex =
            isActive
              ? 0
              : -1;


          if (
            isActive &&
            moveFocus
          ) {

            tab.focus();

          }

        }
      );


      this.panels.forEach(
        (panel) => {

          const isActive =
            panel.dataset.ztSizePanel === name;


          panel.hidden =
            !isActive;


          panel.classList.toggle(
            'is-active',
            isActive
          );

        }
      );

    }


    handleKeydown(
      event,
      currentIndex
    ) {

      let nextIndex =
        currentIndex;


      if (
        event.key === 'ArrowRight' ||
        event.key === 'ArrowDown'
      ) {

        nextIndex =
          (
            currentIndex + 1
          ) %
          this.tabs.length;

      }

      else if (
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowUp'
      ) {

        nextIndex =
          (
            currentIndex
            -
            1
            +
            this.tabs.length
          )
          %
          this.tabs.length;

      }

      else if (
        event.key === 'Home'
      ) {

        nextIndex =
          0;

      }

      else if (
        event.key === 'End'
      ) {

        nextIndex =
          this.tabs.length - 1;

      }

      else {

        return;

      }


      event.preventDefault();


      this.activate(
        this.tabs[nextIndex]
          .dataset
          .ztSizeTab,
        true
      );

    }

  }


  if (
    !customElements.get(
      'zt-size-tabs'
    )
  ) {

    customElements.define(
      'zt-size-tabs',
      ZtSizeTabs
    );

  }


  } catch(e) { console.error(e); }
})();
})();
